/**
 * London Smoke & Cure — site-wide announcements (popup + editor defaults).
 * Aligns with `emailBrandStyles.js` / transactional templates: gold #B99040, body #222, Georgia headings.
 */

import { EMAIL_LOGO_URL, EMAIL_BODY_FONT_STACK, EMAIL_TEXT_PRIMARY, EMAIL_ACCENT_GOLD } from './emailBrandStyles';

export { EMAIL_LOGO_URL };

/** Legacy editor default — treat as “use brand CTA” */
export const LEGACY_CTA_BLUE = '#3b82f6';

export const LSC_ANNOUNCEMENT = {
  popupBodyBg: '#ffffff',
  text: EMAIL_TEXT_PRIMARY,
  textMuted: '#4a4a4a',
  border: '#e8e8e8',
  /** Same as `global.css` `--lsc-logo-header-gradient` (logo header backgrounds). */
  brandGradient: 'linear-gradient(135deg, #B99040 0%, #8B6F2E 100%)',
  titleFont: `Georgia, 'Times New Roman', serif`,
  bodyFont: EMAIL_BODY_FONT_STACK,
  accent: EMAIL_ACCENT_GOLD,
};

/** New announcements / reset editor — replaces generic Tailwind-style blues */
export const LSC_ANNOUNCEMENT_EDITOR_DEFAULTS = {
  bgColor: '#ffffff',
  textColor: '#222222',
  borderColor: '#e5e0d8',
  ctaColor: EMAIL_ACCENT_GOLD,
};

/** Template presets (AnnouncementEditor) */
export const LSC_ANNOUNCEMENT_TEMPLATES = [
  {
    id: 'promo',
    name: 'Promotional',
    icon: '',
    defaults: {
      bgColor: '#faf9f6',
      textColor: '#1a1a1a',
      borderColor: '#e5e0d8',
      title: 'Trade update',
      message: 'Latest news and offers from London Smoke & Cure.',
    },
  },
  {
    id: 'info',
    name: 'Information',
    icon: '',
    defaults: {
      bgColor: '#ffffff',
      textColor: '#222222',
      borderColor: '#d4c4a8',
      title: 'Announcement',
      message: 'Important information for our wholesale customers.',
    },
  },
  {
    id: 'warning',
    name: 'Alert',
    icon: '',
    defaults: {
      bgColor: '#fdf8f0',
      textColor: '#3d2914',
      borderColor: '#c9a227',
      title: 'Please note',
      message: 'Please read this update when you have a moment.',
    },
  },
  {
    id: 'success',
    name: 'Success',
    icon: '',
    defaults: {
      bgColor: '#f4faf6',
      textColor: '#1a2e1f',
      borderColor: '#4AB267',
      title: 'Good news',
      message: 'We have an update we think you will want to see.',
    },
  },
  {
    id: 'ticker',
    name: 'Navbar ticker',
    icon: '',
    defaults: {
      bgColor: '#efe6d0',
      textColor: '#1a1a14',
      borderColor: '#c9a227',
      title: 'Trade update',
      message: 'Latest news and offers from London Smoke & Cure.',
      displayChannels: { popup: false, toast: false, banner: true },
    },
  },
  {
    id: 'productSplash',
    name: 'New product splash',
    icon: '',
    defaults: {
      bgColor: '#ffffff',
      textColor: '#1a1a14',
      borderColor: '#c9a227',
      title: 'Just in',
      headline: 'Just in',
      eyebrow: 'New this week',
      message: 'Now on the wholesale list, ready to order.\n\nAsk us for pack sizes or tasting notes if you would like them for your kitchen.',
      body: 'Now on the wholesale list, ready to order.\n\nAsk us for pack sizes or tasting notes if you would like them for your kitchen.',
      footnote: '',
      ctaText: 'View product',
      addToCartText: 'Add to cart',
      showAddToCart: true,
      showViewProduct: true,
      displayChannels: { popup: true, toast: false, banner: false },
      productSplash: true,
    },
  },
];

/**
 * Whether the saved CTA colour should use the branded gold gradient button.
 */
/** True when the CTA should use the gold gradient (ignores legacy blue default). */
export function shouldUseBrandCtaGradient(ctaColor) {
  const c = (ctaColor || '').trim().toLowerCase();
  return !c || c === LEGACY_CTA_BLUE.toLowerCase() || c === EMAIL_ACCENT_GOLD.toLowerCase();
}
